import React from "react";
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from '@material-ui/core/Icon';
// core components
import GridItem from "@app/components/Grid/GridItem";
import Card from "@app/components/Card/Card";
import CardBody from "@app/components/Card/CardBody";
import CardFooter from "@app/components/Card/CardFooter";
import Button from "@app/components/CustomButtons/Button";

import pricingStyle from "@app/assets/jss/material-kit-pro-react/components/cards/pricingCardStyle";

import check from "@app/assets/img/icons/check.svg";
const PricingCard = props => {
  const { classes } = props;

  Number.prototype.format = function(n, x) {
      var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
      return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
  };
  return (
    <GridItem xs={12} sm={12} md={4} lg={4}>
      <Card raised>
        <CardBody>
          <h3 className={classes.cardCategory + " " + classes.textCenter}>
            {props.product.toUpperCase()}
          </h3>
          <h4 className={classes.cardTitleBig + " " + classes.textCenter}>
            <small>€</small> {props.price.format()}
          </h4>
          <CardFooter className={classes.justifyContentCenter}>
            <Button 
              color="danger" 
              size="lg"
              to={props.action} 
              component={Link}
              aria-label={props.button}>
              <b>
                {props.button}
              </b>
            </Button>
          </CardFooter>
          {props.everythingFrom && <p className={classes.textCenter}><i><b>+&nbsp;{props.everythingFrom.toUpperCase()}</b></i></p>}
          {props.features.map((feature, index) =>
            <div key={index}>
              <h5 className={classes.cardTitle}>
                <Icon className={classes.iconRoot}>
                    <img className={classes.imageIcon} src={check}/>
                </Icon>&nbsp;{feature.name}
              </h5>
              <p className={classes.marginLeft25}>{feature.description}</p>
            </div>
          )}
        </CardBody>
      </Card>
  </GridItem>
  );
}

PricingCard.propTypes = {
  everythingFrom: PropTypes.string
};
    
export default withStyles(pricingStyle)(PricingCard);